import { render } from "./UpdatesPopup.vue?vue&type=template&id=23a4396b&scoped=true"
import script from "./UpdatesPopup.vue?vue&type=script&lang=js"
export * from "./UpdatesPopup.vue?vue&type=script&lang=js"

import "./UpdatesPopup.vue?vue&type=style&index=0&id=23a4396b&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23a4396b"]])

export default __exports__